  
<div class="points__point-actions">    
  @if (!isPointToDelete() && !isPointToReplace()) {
      @if (!isPointToAddNew()) {
        <app-replace-button (replacePointClickEmitter)="handleReplacePointClick()" />
      }
      <app-delete-button (deletePointClickEmitter)="handleDeletePointClick()" />
  } @else {
      <app-recover-button (recoverPointClickEmitter)="handleRecoverPointClick()" />
  }
</div>